import { useMutation } from '@tanstack/react-query';

import CustomerService, {
  UpdateOmnichatCredentialsDto,
} from '@/services/CustomerService';

export function useUpdateOmnichatCredentials() {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (updateOmnichatCredentialsDto: UpdateOmnichatCredentialsDto) =>
      CustomerService.updateOmnichatCredentials(updateOmnichatCredentialsDto),
  });

  return {
    updateOmnichatCredentials: mutateAsync,
    isLoading: isPending,
  };
}
